import {base} from "react-netjoy";
import {UpdateMovieType} from "../../../../pages/parse_new_films/local_state/reducer.types";
import {PendingFilmNetType} from "../../network_models/pending_film";
import {FilmType} from "../../../../models/film";
import {PendingFilmType} from "../../../../models/pending_film";

export function getOnePendingFilm(onSuccess?: (res: PendingFilmType) => void, onFailure?: (error: any) => void) {
    const url = `/admin/pending_film`
    const req = new base.Request<any, PendingFilmType, any>()
    req.setEndpointFromState = () => url
    req.method = 'GET'
    req.transformResponseDataWithState = (res) => {
        console.log(res.original)
        return res.original?.data?.data || {}
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}

export function postPendingFilm(film: PendingFilmType, onSuccess?: (res: any) => void, onFailure?: (error: any) => void) {
    const url = `/admin/pending_film`
    const req = new base.Request()
    req.setEndpointFromState = () => url
    req.method = 'POST'
    req.setBodyFromState = () => {
        return [film]
    }
    req.transformResponseDataWithState = (res) => {
        console.log(res)
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}

export function patchPendingFilmToReview(filmId: number, onSuccess?: (res: any) => void, onFailure?: (error: any) => void) {
    const url = `/admin/pending_film_to_review?id=${filmId}`
    const req = new base.Request()
    req.setEndpointFromState = () => url
    req.method = 'PATCH'
    req.transformResponseDataWithState = (res) => {
        console.log(res)
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}

export function deletePendingFilm(id: number, onSuccess?: (res: any) => void, onFailure?: (error: any) => void) {
    const url = `/admin/pending_film/${id}`
    const req = new base.Request()
    req.setEndpointFromState = () => url
    req.method = 'DELETE'
    req.transformResponseDataWithState = (res) => {
        console.log(res)
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}
